module.exports = __webpack_public_path__ + "img/3.323a6c9b.png";